import {
  BLOCK_UNBLOCK_COUNTRY_SUCCESS,
  BLOCK_UNBLOCK_COUNTRY_FAILED,
  RESET_BLOCK_UNBLOCK_COUNTRY,
  LOADING_BLOCK_UNBLOCK_COUNTRY,
  NETWORK_ERROR_BLOCK_UNBLOCK_COUNTRY,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BLOCK_UNBLOCK_COUNTRY:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case BLOCK_UNBLOCK_COUNTRY_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case BLOCK_UNBLOCK_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_BLOCK_UNBLOCK_COUNTRY:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_BLOCK_UNBLOCK_COUNTRY:
      return (state = initialState);
    default:
      return state;
  }
};
